/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleTemplatesDetails {
    getFixupPrototypeFunction() { return RoleTemplatesDetails.fixupPrototype; }

    static newInstance(model: Partial<RoleTemplatesDetails>): RoleTemplatesDetails {
        let obj = Object.assign(new RoleTemplatesDetails(), model);
        RoleTemplatesDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleTemplatesDetails>): RoleTemplatesDetails {
        if (!model) return null;
        return RoleTemplatesDetails.newInstance(<RoleTemplatesDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleTemplatesDetails) {
        if (!obj) return;

        models.RoleTemplatesDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleTemplatesDetails): boolean {
        Object.setPrototypeOf(obj, RoleTemplatesDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.policies) {
            for (let val of this.policies) {
                models.PolicyActionPair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the role_template
     */
    name: string;

    /**
     * Role of the template defined
     */
    role: string;

    /**
     * Description of the role template
     */
    description: string;

    /**
     * List of policy defined for corresponding role template
     */
    policies: Array<models.PolicyActionPair>;

    /**
     * List of cloud services supported for the role template
     */
    cloud_services: Array<models.CloudServiceName>;

    /**
     * List of integrated tools supported for the role template
     */
    integrated_tools: Array<models.IntegratedToolName>;

    /**
     * List of resources supported for the role template
     */
    resources: Array<models.ResourceName>;

    /**
     * List of SaaS services supported for the role template
     */
    saas_services: Array<models.SaasServiceName>;

}
